<div class="pager" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row" fxLayoutAlign="start center">
    <div class="pager-label">{{ showingDisplay }}</div>
    @if (showChangeRowCount) {
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="pager-label ml-5">{{ 'TABLE.PAGER.TAKE-LABEL' | translate: { value: take } }}</div>
        <topo-action-menu icon="caret_down">
          <topo-action label="10" icon="" (actionClick)="changeRowsPerPage(10)"></topo-action>
          <topo-action label="25" icon="" (actionClick)="changeRowsPerPage(25)"></topo-action>
          <topo-action label="50" icon="" (actionClick)="changeRowsPerPage(50)"></topo-action>
          <topo-action label="100" icon="" (actionClick)="changeRowsPerPage(100)"></topo-action>
        </topo-action-menu>
      </div>
    }
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    @let isFirst = isFirstPage();
    <div>
      <a (click)="isFirst ? null : handlePreviousLink()" class="pager-prev-link" [class.is-disabled]="isFirst">{{ 'TABLE.PAGER.PREV' | translate }}</a>
    </div>
    <div>
      <a (click)="isFirst ? null : handlePreviousLink()" class="pager-arrow" [class.is-disabled]="isFirst">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 12L2 12" stroke="#1A2F42" stroke-width="1.5" stroke-miterlimit="10" />
            <path d="M9 19L2 12L9 5" stroke="#1A2F42" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
          </svg>
        </span>
      </a>
    </div>
    @if (!hidePageLinks) {
      <div fxLayout="row" fxLayoutAlign="center center">
        <ul class="pagination-list">
          <li>
            <a class="pager-link" [class.is-current]="currentPage === 1" (click)="handlePageLink(0)">1</a>
          </li>
          @if (pageLinks[0] > 2) {
            <li>
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
          }
          @for (p of pageLinks; track p) {
            <li>
              <a class="pager-link" [class.is-current]="currentPage === p" (click)="handlePageLink(p)">{{ p }}</a>
            </li>
          }
          @if (totalPages > pageLinks[pageLinks.length - 1] + 1) {
            <li>
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
          }
          @if (totalCount > take) {
            <li>
              <a class="pager-link" [class.is-current]="currentPage === totalPages" (click)="handlePageLink(-1)">{{ totalPages }}</a>
            </li>
          }
        </ul>
      </div>
    }
    @let isLast = isLastPage();
    <div>
      <a (click)="isLast ? null : handleNextLink()" class="pager-arrow" [class.is-disabled]="isLast">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 12H22" stroke="#1A2F42" stroke-width="1.5" stroke-miterlimit="10" />
            <path d="M15 5L22 12L15 19" stroke="#1A2F42" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" />
          </svg>
        </span>
      </a>
    </div>
    <div>
      <a (click)="isLast ? null : handleNextLink()" class="pager-next-link" [class.is-disabled]="isLast">{{ 'TABLE.PAGER.NEXT' | translate }}</a>
    </div>
  </div>
</div>
